import { render, staticRenderFns } from "./createPedidos.vue?vue&type=template&id=6c969754&scoped=true&"
import script from "./createPedidos.vue?vue&type=script&lang=js&"
export * from "./createPedidos.vue?vue&type=script&lang=js&"
import style0 from "./createPedidos.vue?vue&type=style&index=0&id=6c969754&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c969754",
  null
  
)

export default component.exports